<template>
  <div class="processed">
    <div class="container">
      <div class="search-box">
        <!-- 事项描述 -->
        <div class="item">
          <span style="width: 70px">事项描述</span>
          <div class="item-content">
            <el-input
              v-model="processedForm.todo_desc"
              size="small"
              clearable
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <!-- 关联 -->
        <div class="item">
          <span style="width: 70px">关联</span>
          <div class="item-content">
            <el-input
              v-model="processedForm.business_sn"
              size="small"
              clearable
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <!-- 添加时间 -->
        <div class="item">
          <span style="width: 70px">添加时间</span>
          <div class="item-content">
            <el-date-picker
              v-model="processedForm.add_time"
              size="small"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="getList"
            >
            </el-date-picker>
          </div>
        </div>
        <!-- 处理时间 -->
        <div class="item">
          <span style="width: 70px">处理时间</span>
          <div class="item-content">
            <el-date-picker
              v-model="processedForm.handle_time"
              size="small"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="getList"
            >
            </el-date-picker>
          </div>
        </div>
        <!-- 是否解决 -->
        <div class="item">
          <span style="width: 70px">是否解决</span>
          <div class="item-content">
            <el-radio-group v-model="processedForm.handle_status">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">已解决</el-radio>
              <el-radio :label="0">无需处理</el-radio>
            </el-radio-group>
          </div>
          <el-button
            type="primary"
            size="small"
            style="margin-left: 20px"
            @click="getList"
            >查询</el-button
          >
        </div>
      </div>

      <div style="border: solid 1px #c9cbd6">
        <el-table
          v-loading="tableLoading"
          :data="processedData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'create_time'">
                {{ scope.row[item.prop] | dateFormat }}
              </div>

              <div v-else-if="item.prop == 'todo_image'">
                <div
                  v-if="scope.row.todo_image.length"
                  class="flex between"
                  style="width: 300px"
                >
                  <el-image
                    :src="scope.row.todo_image[0]"
                    :preview-src-list="scope.row.todo_image"
                    style="width: 100px; height: 100px"
                  />
                </div>
              </div>

              <div v-else-if="item.prop == 'todo_desc'">
                <el-tooltip
                  effect="dark"
                  :content="scope.row[item.prop]"
                  placement="top-start"
                >
                  <div class="text-container">{{ scope.row[item.prop] }}</div>
                </el-tooltip>
              </div>

              <div v-else-if="item.prop == 'business_sn'">
                <span>{{ scope.row.type | typeText }}：</span>
                <el-link type="primary" @click="getTodoOrderRoute(scope.row)">{{
                  scope.row[item.prop]
                }}</el-link>
              </div>

              <div v-else-if="item.prop == 'remark'">
                <div class="text-container" style="line-clamp: 2">
                  {{ scope.row[item.prop] }}
                </div>
                <el-link
                  v-if="scope.row['log_list'].length"
                  type="primary"
                  @click="viewMoreBtn(scope.row)"
                  >查看更多</el-link
                >
              </div>

              <div v-else-if="item.prop == 'handle_status'">
                <div class="text-container">
                  {{ scope.row[item.prop] | handle_status_text }}
                </div>
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>

    <!-- 查看更多 -->
    <el-dialog title="更多处理结果" :visible.sync="handleResultDia">
      <div style="padding: 20px">
        <el-table :data="handleResultData" border>
          <el-table-column
            prop="admin_user_name"
            label="处理人"
            width="auto"
          ></el-table-column>
          <el-table-column prop="status" label="处理结果" width="auto">
            <template slot-scope="scope">
              {{ scope.row.status | statusText }}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="处理时间" width="auto">
            <template slot-scope="scope">
              {{ scope.row.create_time | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            width="auto"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import kefu from "@/api/kefu.js";
import common from "@/api/common.js";
import Pagination from "@/components/Pagination/index";
import UploadImg from "@/components/uploadImg/index";
export default {
  components: {
    Pagination,
    UploadImg,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      processedForm: {
        status: 1,
        add_time: "",
        handle_time: "",
        handle_status: "",
        todo_desc: "",
        business_sn: "",
      },
      tableHeader: [
        {
          label: "添加时间",
          prop: "create_time",
          width: "160",
          align: "center",
          fixed: "left",
        },
        {
          label: "事项描述",
          prop: "todo_desc",
          width: "300",
          align: "center",
          fixed: false,
        },

        {
          label: "事项截图",
          prop: "todo_image",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "关联",
          prop: "business_sn",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "添加人",
          prop: "admin_user_name",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "处理记录",
          prop: "remark",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "是否解决",
          prop: "handle_status",
          width: "80",
          align: "center",
          fixed: false,
        },
      ],
      processedData: [],
      handleResultDia: false,
      handleResultData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    dateFormatSS(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "已解决";
        case 2:
          return "未解决";
        case 3:
          return "无需处理";
      }
    },
    typeText(val) {
      switch (val) {
        case 1:
          return "处方";
        case 2:
          return "诊疗订单";
        case 3:
          return "商城订单";
      }
    },
    handle_status_text(val) {
      switch (val) {
        case 1:
          return "已解决";
        case 0:
          return "无需处理";
        default:
          return "-";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.processedForm.add_time = [start, end];
    },
    getList() {
      let params = Object.assign({}, this.pagination, this.processedForm);
      params = _.omit(params, ["add_time", "handle_time"]);
      let times = this.processedForm.add_time;
      params["add_start_time"] = times ? times[0] : "";
      params["add_end_time"] = times ? times[1] : "";
      let handleTimes = this.processedForm.handle_time;
      params["handle_start_time"] = handleTimes ? handleTimes[0] : "";
      params["handle_end_time"] = handleTimes ? handleTimes[1] : "";
      this.tableLoading = true;
      kefu
        .getTodoList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.processedData = data.list;
            this.totalNum = data.total;
          }
          this.tableLoading = false;
        })
        .catch((err) => (this.tableLoading = false));
    },
    // 跳转路由
    getTodoOrderRoute(row) {
      let { type, business_sn } = row;
      const loading = this.$loading();
      kefu
        .getTodoOrderRoute({ type, business_sn })
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.$router.push({
              path: data.url,
            });
          }
          loading.close();
        })
        .catch((err) => loading.close());
    },
    // 查看更多
    viewMoreBtn(row) {
      this.handleResultData = row.log_list;
      this.handleResultDia = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.processed {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 90px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .text-container {
    overflow: hidden; /* 隐藏溢出文本 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* 限制显示三行 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    line-height: 20px; /* 行高 */
  }
}
</style>
